<div class="row domain-groups-match-label-fields">
    <div *ngIf="rule.match !== 'labels'"
         class="col-lg-45">
        <div class="row">
            <div class="col-md-24 col-lg-9" [attr.aria-label]="'Rule to match' | translate">
                <form-field-select name="match"
                                   [(ngModel)]="rule.match"
                                   [options]="matchOptions"
                                   returnValue="value"
                                   [required]="true">
                </form-field-select>
            </div>

            <div class="col-md-24 col-lg-11" [attr.aria-label]="'Matches' | translate">
                <form-field-select name="match_rules"
                                   [(ngModel)]="rule.match_rule"
                                   [options]="matchRulesOptions"
                                   returnValue="value"
                                   [label]="'that' | translate"
                                   [required]="true">
                </form-field-select>
            </div>
            <div class="col-md-48 col-lg-9" *ngIf="rule.match === 'metadata'" [attr.aria-label]="'Metadata key' | translate">
                <form-field-input name="key"
                                  [(ngModel)]="rule.key"
                                  [placeholder]="'Type the key for the metadata' | translate"
                                  [required]="rule.match === 'metadata'"
                                  type="text">
                </form-field-input>
            </div>
            <div [ngClass]="{ 'col-md-24 col-lg-9' : rule.match == 'metadata', 'col-md-24 col-lg-18' : rule.match != 'metadata' }"
                 [attr.aria-label]="'Text to match' | translate">
                <form-field-input name="text"
                                  [(ngModel)]="rule.text"
                                  [placeholder]="'Type the text to match rule' | translate"
                                  [required]="true"
                                  type="text">
                </form-field-input>
            </div>
            <div class="col-md-24 col-lg-10" [attr.aria-label]="'Constraint' | translate">
                <form-field-select name="exclude"
                                   [(ngModel)]="rule.exclude"
                                   [options]="matchExcludeOptions"
                                   returnValue="value"
                                   [label]="'is' | translate"
                                   [required]="true"
                                   (ngModelChange)="handleExcludeChange()">
                </form-field-select>
            </div>
        </div>
    </div>
    <div *ngIf="rule.match === 'labels'"
         class="col-lg-45">
        <mon-form-domain-groups-match-rule-label [monRule]="rule"
                                                 [monMatchOptions]="matchOptions"
                                                 [monMatchExcludeOptions]="matchExcludeOptions"
                                                 [monLabelsOptions]="labels"
                                                 [monFieldKey]="key"
                                                 (monExcludeChange)="handleExcludeChange()">
        </mon-form-domain-groups-match-rule-label>
    </div>

    <div class="col-sm-48 col-lg-3 text-right" [attr.aria-label]="'Remove rule' | translate">
        <button
                [attr.aria-label]="'Remove rule' | translate"
                [ngbTooltip]="'Remove rule' | translate"
                type="button"
                class="btn btn-border-radius btn-secondary"
                monModalConfirm="{{ 'Are you sure you want to remove this rule?' | translate }}"
                (monModalConfirmAction)="handleConfirmRemove(rule)">
            <span class="fas fa-trash-alt" aria-hidden="true"></span>
        </button>
    </div>
</div>
